import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvService } from 'src/app/services/env.service';
import { UserService } from 'src/app/core/services/user.service';
import { Observable, Subject } from 'rxjs';
import { IAlert } from 'src/app/components/malla/interfaces/IAlertInfo';

export interface IAccion {
  _id?: string;
  instrument?: string;
  type_person?: string;
  identify: number;
  nombre?: string;
  extraInformation: { apellido: string; nombre: string };
  ip: string;
  action: string;
  date: string;
}

export interface UserAndIp {
  users: string[];
  ips: string[];
  identificacion: string[];
}

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  readonly baseUrl = `${this.env.URL_API_V1}/alert`;
  readonly timelineUrl = `${this.env.URL_API_V1}/action`;

  readonly apiVU = `${this.env.URL_API_V1}/getdataMd`;

  constructor(
    private env: EnvService,
    private readonly http: HttpClient,
    private userService: UserService
  ) {}
  alertCreated = new Subject<any>();
  alertImportedVu = new Subject<any>();
  alertEdited = new Subject<any>();
  filterDataSearch = new Subject();
  caseStyleContent = new Subject<string>();
  filterDataAlert = new Subject<any>();
  alertChangeFilterDash = new Subject<any>();
  proceedAlert = new Subject<any>();
  refusedAlert = new Subject<any>();
  toHeaderInfo = new Subject<any>();
  alertInProcess: IAlert = null;
  alertProcesFinished = new Subject();
  filtroUrgentes = new Subject();
  mandaValorUrgente = new Subject();

  get getAlertInProcess() {
    return this.alertInProcess;
  }

  createAlert(alert) {
    return this.http.put<any[]>(`${this.baseUrl}/create`, alert);
  }

  getAlert(id) {
    return this.http.get<any>(`${this.baseUrl}/get/${id}`);
  }

  getAlerts() {
    return this.http.get<any[]>(`${this.baseUrl}/getAlerts`);
  }

  updateAlert(id, alert) {
    return this.http.post<any[]>(`${this.baseUrl}/updateAlerts/${id}`, {
      alert,
      user: this.userService.currentUser,
    });
  }
  getalertByList(filters) {
    return this.http.get<any[]>(`${this.baseUrl}/getalertByList`, {
      params: filters,
    });
  }

  deleteAlert(id) {
    return this.http.post<any[]>(
      `${this.baseUrl}/deleteAlert/${id}`,
      this.userService.currentUser
    );
  }

  carga(alertas: Partial<IAlert>[], acciones: any): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/carga`, { alertas, acciones });
  }

  getAccionesByDates(
    startDate: string,
    endDate: string,
    identificacion: string,
    users: string[],
    ips: string[]
  ): Observable<IAccion[]> {
    return this.http.post<IAccion[]>(`${this.baseUrl}/getAccionesByDates`, {
      startDate,
      endDate,
      identificacion,
      users,
      ips,
    });
  }

  getUsersAndIps(): Observable<UserAndIp> {
    return this.http.get<UserAndIp>(`${this.baseUrl}/getUsersAndIps`);
  }

  importVuData() {
    return this.http.get<any[]>(`${this.apiVU}/get`);
  }

  vuExample(alerta: Partial<IAlert>) {
    return this.http.post<any[]>(`${this.baseUrl}/create-api-vu`, alerta);
  }
  remmitAlertAn(alerta: Partial<IAlert>) {
    return this.http.post<any[]>(`${this.baseUrl}/remmitAlertAn`, alerta);
  }
  remmitAlertCSA(id: string, idUser: string) {
    return this.http.post<any[]>(
      `${this.baseUrl}/remmitAlertCasosSinAsignar/${id}`,
      { id: idUser }
    );
  }

  getAlertReport(filters) {
    return this.http.get<any[]>(`${this.baseUrl}/reports`, {
      params: filters,
    });
  }
  getReportsDetail(filters) {
    return this.http.get<any[]>(`${this.baseUrl}/reportsDetail`, {
      params: filters,
    });
  }

  importFileToTimeLine(file: FormData) {
    return this.http.post<any[]>(`${this.timelineUrl}/importFile`, file);
  }
  getActionsFromExternalDB() {
    return this.http.get<any[]>(`${this.timelineUrl}/getActionsFromExternalDB`);
  }

  getActionsByIdentifyOfCase(data) {
    return this.http.put<any[]>(
      `${this.timelineUrl}/getActionsByIdentifyOfCase`,
      data
    );
  }

  searchActionsByFilters(data: any) {
    return this.http.put<any[]>(
      `${this.timelineUrl}/searchActionsByFilters`,
      data
    );
  }
}
